import { FormFieldGroup, FormInput, FormLabel, FormCheckbox } from '$components'
import { Input } from './index'

export function EditMedicalDetailsContent() {
  return (
    <div className="flex flex-col gap-6 flex-grow">
      <FormFieldGroup>
        <FormLabel htmlFor={Input.MicrochipNumber}>
          Microchip Number
        </FormLabel>
        <FormInput
          name={Input.MicrochipNumber}
          placeholder="Enter microchip number..."
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.Weight}>
          Weight (kg)
        </FormLabel>
        <FormInput
          name={Input.Weight}
          type="number"
          min={0}
          placeholder="0.00"
        />
      </FormFieldGroup>

      <FormFieldGroup className="col-span-2">
        <FormCheckbox
          name={Input.Vaccinated}
          label="Is Vaccinated?"
        />
      </FormFieldGroup>
    </div>
  )
}
